import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import PayrollEmployeesReport from "../../components/PayrollReports/PayrollEmployeesReport";

export default function PayrollEmployeeReports() {
  const merchantInfo = useSelector((state) => state.login.user);

  return (
    <Box className="page-container">
      <Box className="header-container" sx={{ mb: 4 }}>
        <Typography className="page-title">Payroll Employee List</Typography>
      </Box>
      <PayrollEmployeesReport adminId={merchantInfo?.id} />
    </Box>
  );
}
